import { Order } from "./Order";
import { AllOrders } from "./AllOrders";
import "./styles.scss";

export default { Order, AllOrders };
